import React from "react";
import Stack from "../../components/Stack";

import {
  AirConditioner,
  Blackboard,
  Plug,
  Projector,
  VideoConference,
  Wifi,
  Monitor,
  ExpandableRoom,
  Phone
} from '../../../svgs/Amenities'

const getCurrentBrowser = () => {
  var ua = navigator.userAgent
  var tem
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return 'IE ' + (tem[1] || '')
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera')
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
  return M.join(' ');
}

const getLocalitation = (reservation = {}) => {
  const site = reservation?.site?.name || ''
  const building = reservation.building?.name || ''
  const floor = reservation?.floor?.name || ''

  const items = [site, building, floor]
  return items.filter(i => i !== '').join(', ')
}

const defaultFunction = () => { }

const sortItems = (items = []) => {
  return items.sort((a, b) => {
    const _a = a.name.toLowerCase()
    const _b = b.name.toLowerCase()

    if (_a < _b) return -1
    else if (_a > _b) return 1
    return 0
  })
}

const getAmenitieImage = (i, t) => {
  if (i === 0) return <Stack gap={6} direction="row" justifyContent="center"><AirConditioner width={16} /> <span>{t('Airconditioner')}</span> </Stack>
  if (i === 1) return <Stack gap={6} direction="row" justifyContent="center"><Blackboard width={16} /> <span>{t('Blackboard')}</span> </Stack>
  if (i === 2) return <Stack gap={6} direction="row" justifyContent="center"><Plug width={16} /> <span>{t('Plug')}</span> </Stack>
  if (i === 3) return <Stack gap={6} direction="row" justifyContent="center"><Projector width={16} /> <span>{t('Projector')}</span> </Stack>
  if (i === 4) return <Stack gap={6} direction="row" justifyContent="center"><VideoConference width={16} /> <span>{t('Videoconference')}</span> </Stack>
  if (i === 5) return <Stack gap={6} direction="row" justifyContent="center"><Wifi width={16} /> <span>{t('Wifi')}</span> </Stack>
  if (i === 6) return <Stack gap={6} direction="row" justifyContent="center"><Monitor width={16} /> <span>{t('Monitor')}</span> </Stack>
  if (i === 7) return <Stack gap={6} direction="row" justifyContent="center"><ExpandableRoom width={20} /> <span>{t('Expandable')}</span> </Stack>
  if (i === 8) return <Stack gap={6} direction="row" justifyContent="center"><Phone width={16} /> <span>{t('Phone')}</span> </Stack>
}

const autoSetPlace = (sites = [], {
  setSite = defaultFunction,
  setBuildings = defaultFunction,
  setBuilding = defaultFunction,
  setFloors = defaultFunction,
  setFloor = defaultFunction,
  setFloorMapId = defaultFunction
}) => {
  if (sites.length === 1) {
    const siteItem = sites[0]
    setSite(siteItem.id)
    setBuildings(siteItem.buildings)
 
    const buildingItem = siteItem.buildings[0]
    if (siteItem.buildings.length === 1) {
      setBuilding(buildingItem.id)
      setFloors(buildingItem.floors)
 
      const floorItem = buildingItem.floors[0]
      if (buildingItem.floors.length === 1) {
        setFloor(floorItem.id)
        setFloorMapId(floorItem.floor_map.id)
      }
    }
  }
}

const autoSetSite = (id, methods) => {
  const {
    sites = [],
    setSite = defaultFunction,
    setBuildings = defaultFunction,
    setBuilding = defaultFunction,
    setFloors = defaultFunction,
    setFloor = defaultFunction,
    setFloorMapId = defaultFunction
  } = methods
  const site = id;

  if(site === "") {
    setSite("")
    setBuildings([])
    setBuilding("")
    setFloors([])
    setFloor("")
    setFloorMapId("")
    return
  }

  let buildings = sites.find(s => s.id === Number(site)).buildings || [];
  buildings = sortItems(buildings)
  setSite(Number(site))
  setBuildings(buildings)
  setBuilding('')

  if (buildings.length === 1) {
    methods.buildings = buildings
    autoSetBuilding(buildings[0].id, methods)
  }
}

const autoSetBuilding = (id, methods) => {
  const {
    buildings = [],
    setBuilding = defaultFunction,
    setFloors = defaultFunction,
    setFloor = defaultFunction,
    setFloorMapId = defaultFunction
  } = methods

  if (!buildings.length) return
  const building = id;

  if(building === "") {
    setBuilding("")
    setFloors([])
    setFloor("")
    setFloorMapId("")
    return
  }

  let floors = buildings.find(b => b.id === Number(building)).floors || [];
  floors = sortItems(floors)
  setBuilding(building)
  setFloors(floors)
  setFloor('')
  setFloorMapId('')

  if (floors.length === 1) {
    methods.floors = floors
    autoSetFloor(floors[0].id, methods);
  }
}

const autoSetFloor = (id, methods) => {
  const { 
    floors = [],
    setFloor = defaultFunction,
    setFloorMapId = defaultFunction
  } = methods

  if (!floors.length) return
  const floor =  id

  if(floor === "") {
    setFloor("")
    setFloorMapId("")
    return
  }

  setFloor(floor)
  setFloorMapId(floors.find(f => f.id === Number(floor)).floor_map.id)
}

export {
  autoSetPlace,
  autoSetSite,
  autoSetBuilding,
  autoSetFloor,
  getAmenitieImage,
  sortItems,
  defaultFunction,
  getLocalitation,
  getCurrentBrowser
}